/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Account_Out_Of_ScopeInputs */

const en_ledger_error_account_out_of_scope = /** @type {(inputs: Ledger_Error_Account_Out_Of_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the accounts is not part of this dossier's ledger`)
};

const nl_ledger_error_account_out_of_scope = /** @type {(inputs: Ledger_Error_Account_Out_Of_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een van de rekeningen hoort niet bij het grootboek van dit dossier`)
};

/**
* | output |
* | --- |
* | "One of the accounts is not part of this dossier's ledger" |
*
* @param {Ledger_Error_Account_Out_Of_ScopeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_account_out_of_scope = /** @type {((inputs?: Ledger_Error_Account_Out_Of_ScopeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Account_Out_Of_ScopeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_account_out_of_scope(inputs)
	return en_ledger_error_account_out_of_scope(inputs)
});